var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#32A840",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 20V26C28 28.21 26.21 30 24 30H16C13.79 30 12 28.21 12 26V20C12 19.45 12.45 19 13 19H14.97C15.52 19 15.97 19.45 15.97 20V23.14C15.97 23.88 16.38 24.56 17.03 24.91C17.32 25.07 17.64 25.15 17.97 25.15C18.35 25.15 18.73 25.04 19.06 24.82L20.01 24.2L20.89 24.79C21.5 25.2 22.28 25.25 22.93 24.9C23.59 24.55 24 23.88 24 23.13V20C24 19.45 24.45 19 25 19H27C27.55 19 28 19.45 28 20Z",
    fill: "#32A840"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 15V16C29.5 17.1 28.97 18 27.5 18H12.5C10.97 18 10.5 17.1 10.5 16V15C10.5 13.9 10.97 13 12.5 13H27.5C28.97 13 29.5 13.9 29.5 15Z",
    fill: "#32A840"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6427 12.9995H14.1227C13.7827 12.6295 13.7927 12.0595 14.1527 11.6995L15.5727 10.2795C15.9427 9.90945 16.5527 9.90945 16.9227 10.2795L19.6427 12.9995Z",
    fill: "#32A840"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8716 12.9995H20.3516L23.0716 10.2795C23.4416 9.90945 24.0516 9.90945 24.4216 10.2795L25.8416 11.6995C26.2016 12.0595 26.2116 12.6295 25.8716 12.9995Z",
    fill: "#32A840"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9675 19C22.5175 19 22.9675 19.45 22.9675 20V23.13C22.9675 23.93 22.0775 24.41 21.4175 23.96L20.5175 23.36C20.1875 23.14 19.7575 23.14 19.4175 23.36L18.4775 23.98C17.8175 24.42 16.9375 23.94 16.9375 23.15V20C16.9375 19.45 17.3875 19 17.9375 19H21.9675Z",
    fill: "#32A840"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg02);
export default __webpack_public_path__ + "static/media/02.e470c4138c3764f5c8855d66bf2bfd19.svg";
export { ForwardRef as ReactComponent };